import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Project from "@/components/Project";
import Carriers from "@/components/Carriers";
import Portal from "@/components/Portal";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings(r.data))
      .catch(() => setSettings(null));
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#070F1E] text-slate-100">
      <Nav settings={settings} />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Project />
        <Carriers />
        <Portal settings={settings} />
        <Contact settings={settings} />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors theme="dark" />
    </div>
  );
}
